import type { MarketVariants } from '@/lib/i18n'

export type Slide10Copy = {
  title: string
}

export const copy: MarketVariants<Slide10Copy> = {
  US: {
    title: "But the damage they do\nisn't just financial.",
  },
  ar: {
    title: 'لكن الضرر الذي يسببونه\nليس مالياً فقط.',
  },
}
